import api from "../config/api";

export const fetchAllPages = async () => {
  const res = await api.get("/pages/");
  return res.data.data;
};

export const fetchPagesById = async (id) => {
  const res = await api.get(`/pages/?id=${id}`);
  return res.data.data;
};

export const createPages = async (formData) => {
  const res = await api.post(`/pages/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updatePages = async (id, formData) => {
  const res = await api.post(`/pages/?id=${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deletePages = async (id) => {
  const res = await api.delete(`/pages/?id=${id}`);
  console.log(res);

  return res.data;
};
